import { useQuery } from 'libs/query'
import { useParams } from 'libs/router'
import { useAxiosPrivate } from 'shared/hooks'
import { BookingRes } from 'features/bookings/types/bookings.types'
import { apiRoutes } from 'config/apiRoutes'
import { useContext } from 'react'
import { AuthContext } from 'store'
import { queryKeys } from 'config/queryKeys'

const MAX_RETRIES = 3

export const useFetchBooking = () => {
	const axiosPrivate = useAxiosPrivate()
	const params = useParams()
	const { auth } = useContext(AuthContext)

	const { data: booking, error } = useQuery<BookingRes>({
		queryKey: queryKeys.bookings.detail(params.id as string),
		queryFn: () => axiosPrivate.get(apiRoutes.booking(params.id as string)),
		enabled: !!auth.accessToken,
		retry: (failureCount, err: any) => err?.response?.status !== 404 && failureCount < MAX_RETRIES
	})

	return {
		booking,
		isBookingNotFound: (error as any)?.response?.status === 404
	}
}
